import type { ClientApprovalAction, LawyerApprovalAction } from '@common/enums';
import type { ApprovalRequestBody, ApprovalResponse } from '@common/types';
import axiosInstance from '@/services/axiosInstance';

export async function getLawyerApprovalStatus(
    instanceId: string,
    prospectId: string,
    action: LawyerApprovalAction | null,
    data: ApprovalRequestBody | null,
) {
    return axiosInstance.post<ApprovalResponse>(
        `api/v1/lawyerapproval/${instanceId}/${prospectId}`,
        data,
        {
            headers: { 'Content-Type': 'application/json' },
            params: { Action: action },
        },
    );
}

export async function getClientApprovalStatus(
    instanceId: string,
    prospectId: string,
    action: ClientApprovalAction | null,
    data: ApprovalRequestBody | null,
) {
    return axiosInstance.post<ApprovalResponse>(
        `api/v1/clientapproval/${instanceId}/${prospectId}`,
        data,
        {
            headers: { 'Content-Type': 'application/json' },
            params: { Action: action },
        },
    );
}

export async function checkStatusOfApprovalEmail(instanceId: string, prospectId: string) {
    return axiosInstance.get<ApprovalResponse>(
        `api/v1/clientApproval/${instanceId}/${prospectId}/status`,
    );
}

export async function getIntakeFormStatus(instanceId: string, prospectId: string) {
    return axiosInstance.get<ApprovalResponse>(
        `api/v1/intakeForm/${instanceId}/${prospectId}/status`,
    );
}
